import { X } from "lucide-react";

export default function CancelConfirmModal({ open, t, busy, result, onConfirm, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="cancel-confirm-modal">
      <div className="w-full max-w-md tech-card p-6 border-red-500/40">
        <div className="flex items-center gap-2 mb-3">
          <X size={18} className="text-red-400"/>
          <div className="font-display font-bold text-lg text-slate-100">{t("billing.cancelConfirmTitle")}</div>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">{t("billing.cancelConfirmBody")}</p>

        {result && (
          <div className={`mt-4 px-3 py-2 rounded-md text-xs ${result.ok ? "bg-emerald-500/10 border border-emerald-500/40 text-emerald-300" : "bg-red-500/10 border border-red-500/40 text-red-300"}`} data-testid="cancel-result">
            {result.ok
              ? (result.mode === "live" ? t("billing.cancelLiveSuccess") : t("billing.cancelTestSuccess"))
              : result.error}
          </div>
        )}

        <div className="mt-5 flex items-center justify-end gap-2">
          <button onClick={onClose} disabled={busy} className="px-4 py-2 rounded-md text-sm bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700" data-testid="cancel-confirm-no">
            {t("common.no")}
          </button>
          <button onClick={onConfirm} disabled={busy || result?.ok} className="px-4 py-2 rounded-md text-sm bg-red-600 hover:bg-red-500 text-white disabled:opacity-50" data-testid="cancel-confirm-yes">
            {busy ? t("common.loading") : t("billing.cancelConfirmYes")}
          </button>
        </div>
      </div>
    </div>
  );
}

export function UsageBar({ label, value, max }) {
  const safeMax = max || 1;
  const pct = Math.min(100, (value / safeMax) * 100);
  const isMax = value >= safeMax;
  return (
    <div className="tech-card p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="label-tech">{label}</div>
        <div className={`font-mono-data text-sm ${isMax ? "text-red-400" : "text-slate-200"}`}>{value} / {safeMax}</div>
      </div>
      <div className="h-2 rounded-full bg-slate-800 overflow-hidden">
        <div className={`h-full ${isMax ? "bg-red-500" : "bg-blue-500"}`} style={{ width: `${pct}%` }}/>
      </div>
    </div>
  );
}

export function Perk({ icon, title, body }) {
  return (
    <div className="tech-card p-5">
      <div className="w-10 h-10 rounded-md bg-blue-500/10 text-blue-400 flex items-center justify-center mb-3">{icon}</div>
      <div className="font-display font-semibold text-slate-100 mb-1">{title}</div>
      <div className="text-xs text-slate-400">{body}</div>
    </div>
  );
}
